import * as Sentry from '@sentry/react';

export const captureErrorString = (error: string): void => {
    console.error(error);
    try {
        Sentry.captureException(new Error(error));
    } catch (e) {
        console.log(e);
    }
};

export const captureError = (error: Error): void => {
    console.error(error);
    try {
        Sentry.captureException(error);
    } catch (e) {
        console.log(e);
    }
};
